<template>
  <div class="animated fadeIn">
    <b-card class="mt-4">
      <project-field-form-group :submissionId="submissionId" />
      <div v-if="samples && samples.length">
        <hr />
        <template v-for="(sample, index) in samples">
          <project-general-sample-form-group
            :key="index"
            :submissionId="submissionId"
            :sampleId="sample.test_package_sample_id"
            :addOns="addOns"
          />
        </template>
      </div>
      <turn-around-select
        :submissionId="submissionId"
        :turnArounds="turnArounds"
      />
      <div v-if="serviceQuestions && serviceQuestions.length">
        <hr />
        <template v-for="(question, index) in serviceQuestions">
          <service-question :key="index" :serviceQuestion="question" />
        </template>
      </div>
    </b-card>
  </div>
</template>
<script>
import ProjectFieldFormGroup from "../../misc/ProjectFieldFormGroup";
import ProjectGeneralSampleFormGroup from "./ProjectGeneralSampleFormGroup";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import TurnAroundSelect from "../../misc/TurnAroundSelect";
import { validationMixin } from "vuelidate/src";
import { required, minLength } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProjectGeneralSubmissionForm",
  components: {
    ProjectFieldFormGroup,
    ProjectGeneralSampleFormGroup,
    TurnAroundSelect,
  },
  mixins: [validationMixin, ToastNotifications],
  props: {
    submissionId: {
      type: String,
      default: "",
    },
    addOns: {
      type: Array,
      default: () => [],
    },
    serviceQuestions: {
      type: Array,
      default: () => [],
    },
    turnArounds: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission",
    }),
    currentSubmission() {
      return this.submission(this.submissionId);
    },
    samples() {
      return this.currentSubmission.samples;
    },
    isValid() {
      return this.$v && !this.$v.$invalid;
    },
  },
  validations: {
    currentSubmission: {
      test_package_id: { required },
      turnaround_id: { required },
      samples: { required, minLength: minLength(1) },
    },
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    handleSubmissionUpdate(value, field) {
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value,
        name: field,
      });
    },
  },
};
</script>
